export const getInitials = (name: string, locale: string): string => {
  if (!name) return "?";

  const wordSegmenter = new Intl.Segmenter(locale, { granularity: "word" });
  const graphemeSegmenter = new Intl.Segmenter(locale, { granularity: "grapheme" });

  const words = [...wordSegmenter.segment(name)].filter((s) => s.isWordLike).slice(0, 2);

  if (words.length === 0) return "?";

  return words
    .map((w) => [...graphemeSegmenter.segment(w.segment)][0]?.segment ?? "")
    .join("")
    .toLocaleUpperCase(locale);
};
